import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Grant } from '../_models/grant';
import { GrantFile } from '../_models/grantFile';
import { Note } from '../_models/note';
import { NoteList } from '../_models/notelist';
import { Status } from '../_models/status';
import { GrantListItem } from '../_models/grant-list-item';
import { HouseholdMember } from '../_models/household-member';
import { AuthenticationService } from '../_services/authentication.service';
import { environment } from '../../environments/environment';
declare let ga: Function;

@Injectable()
export class GrantService {
    constructor(
        private http: Http, 
        private authenticationService: AuthenticationService
    ) { }

    getAll(): Promise<GrantListItem[]> {
      return this.http.get(environment.apiUrl + 'applications')
        .toPromise()
        .then((response: Response) => response.json())
        .catch(x => console.log(x));
    }

    getById(id: string): Promise<Grant> {
      return this.http.get(environment.apiUrl + 'applications/' + id)
        .toPromise()
        .then((response: Response) => response.json())
        .catch(err => {
            console.log(err);
            //throw err;
        });
    }

    editStatus(grant: Grant, status: Status, organizationId: string): Promise<Grant> {
        let url = environment.apiUrl + 'applications/' + grant.id;

        if (this.authenticationService.permissions.canProcessApplications){

            let body = JSON.stringify({ status_id: status.id });

            return this.http.patch(url, body)
                .toPromise()
                .then((response: Response) => {
                    grant.status_id = status.id;
                    grant.status_name = status.name;

                    return response.json();
                })
                .catch(x => console.log(x));
        }
    }

    submitGrantWithHouseholdMembers(grant: Grant, householdMembers: HouseholdMember[], files: FileList): Promise<[Grant, HouseholdMember[], GrantFile[]]> {
      return this.submitGrant(grant)
        .then((data: Grant) => {
          return Promise.all([Promise.resolve(data), this.submitHouseholdMembers(data.id, householdMembers), this.uploadFiles(data.id, files)]);
        });
    }

    private submitGrant(grant: Grant): Promise<Grant> {
        //if a new grant...
        if(!grant.id){
          ga('send', 'event', 'Grants', 'Submitted', this.authenticationService.currentUser.organization, this.authenticationService.currentUser.organization_id);
          //Let's always set a submitted grant to status "New"
          grant.status_id = "2";
          
          return this.http.post(environment.apiUrl + 'applications', grant)
            .toPromise()
            .then((response: Response) => response.json())
            .catch(x => console.log(x));
        } else {
          //if updating a grant...

          //If resubmitting a grant that was marked as "more info needed", auto-update the status to "New"
          if (grant.status_id == "3") {
            grant.status_id = "2";
          }
          
          return this.http.patch(environment.apiUrl + 'applications/' + grant.id, grant)
            .toPromise()
            .then((response: Response) => response.json())
            .catch(x => console.log(x));
        }
    }

    private submitHouseholdMembers(grantId: string, members: HouseholdMember[]): Promise<HouseholdMember[]> {
      //let membersToAdd = members.filter((member: HouseholdMember) => { !member.id });
      //let membersToUpdate = members.filter((member: HouseholdMember) => { member.id });
      let membersToAdd = members.filter(m => !m.id);
      let membersToUpdate = members.filter(m => m.id);
      let promises = [];

      if (membersToAdd.length) {
        let add = this.http.post(environment.apiUrl + 'applications/' + grantId + '/householdmembers', membersToAdd)
          .toPromise()
          .then((response: Response) => response.json());
         promises.push(add);
      }

      if (membersToUpdate.length) {
        let update = this.http.put(environment.apiUrl + 'applications/' + grantId + '/householdmembers', membersToUpdate)
          .toPromise()
          .then((response: Response) => response.json());
        promises.push(update);
      }

      return Promise.all(promises).then(() => {
        return this.getHouseholdMembersByGrantId(grantId);
      });
    }

    getHouseholdMembersByGrantId(id: string): Promise<HouseholdMember[]> {
      return this.http.get(environment.apiUrl + 'applications/' + id + '/householdmembers')
        .toPromise()
        .then((response: Response) => response.json())
        .catch(x => console.log(x));
    }

    deleteHouseholdMembersByGrantId(id: string, memberId: string) {
      return this.http.delete(environment.apiUrl + 'applications/' + id + '/householdmembers/'+ memberId)
        .toPromise();
    }

    // Notes Handling
    getNotesByGrantId(id: string): Promise<NoteList[]> {
      return this.http.get(environment.apiUrl + 'applications/' + id + '/notes')
        .toPromise()
        .then((response: Response) => response.json())
        .catch(x => console.log(x));
    }

    submitNote(grantId: string, note: Note): Promise<Note> {
        return this.http.post(environment.apiUrl + 'applications/' + grantId + '/notes', note)
            .toPromise()
            .then((response: Response) => response.json())
            .catch(x => console.log(x));
    }




    // File Handling
    getFiles(grantId: number) {
      return this.http.get(environment.apiUrl + 'applications/' + grantId + '/files')
        .toPromise()
        .then((response: Response) => response.json());
    }

    deleteFile(fileId: number, grantId: number) {
      return this.http.delete(environment.apiUrl + 'applications/' + grantId + '/files/'+ fileId)
        .toPromise();
    }

    uploadFiles(grantId: string, files: FileList) {
      if (files) {
        let promises = [];

        Array.from(files).forEach(file => {
          promises.push(this.uploadFile(grantId, file));
        });

        return Promise.all(promises);
      } else {
        return Promise.resolve();
      }
    }

    uploadFile(grantId: string, file: File) {
      let url = environment.apiUrl + 'applications/' + grantId + '/files';

      let formData:FormData = new FormData();
      formData.append('file', file, file.name);

      let headers = new Headers();
      headers.append('Accept', 'application/json');
      let options = new RequestOptions({ headers: headers });

      return this.http.post(url, formData, options)
        .toPromise()
        .then((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/grant.service.ts